import styled from "styled-components";
import Box from "../Box";
import {
  Colors,
  NEW_PARK_VISIT_TIME_INIT,
  OUTLET_TYPES,
  OUTLET_TYPES_PARK,
} from "../../config/Constants";
import Textfield from "../Merchant/Textfield";
import Selectfield from "../Merchant/Selectfield";
import Button from "../Button";
import TextfieldWithImage from "./TextFieldWithImage";
import UploadOutletImages from "./UploadLogoImages";
import TextArea from "./TextArea";
import countryCodeData from "../../pages/AddOutlet/countries";
import UploadParkImages from "./UploadParkImages";
import TimeRangeSelector from "../TimeRange";
import DynamicPromoForm from "./DynamicPromoForm";
import MultiDateSelector from "../MultiDateSelector";
import RestrictProductDiscount from "./RestrictProductDiscount";

interface Props {
  id: string | undefined;
  onSubmit: () => void;
  onChange: (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLTextAreaElement>
  ) => void;
  onCancel: () => void;
  onRemove: (e: any) => void;
  value: {
    name: string;
    type: string;
    email: string;
    countryCode: string;
    phoneNumber: string;
    info: string;
    whatsappNumber: string;
    instaLink: string;
    fbLink: string;
    lat: string;
    long: string;
    address: string;
    iframe_url: string;
    tripAdvisor: string;
    logoUrl: string[];
    imageUrl: string[];
    masterName: string;
    masterEmail: string;
    bankName: string;
    accountNumber: string;
    legalEntity: string;
    sapCode: string;
    disclaimer: string;
    tc: string;
    segrateTimeSlot: string;
    mapImage: string[];
    specialProductsDates: string[];
    holidayAllowedDates: string[];
    restrictedDates: string[];
  };
  error: {
    name: string;
    type: string;
    email: string;
    countryCode: string;
    phoneNumber: string;
    info: string;
    whatsappNumber: string;
    instaLink: string;
    fbLink: string;
    lat: string;
    long: string;
    address: string;
    iframe_url: string;
    tripAdvisor: string;
    logoUrl: string;
    imageUrl: string;
    masterName: string;
    masterEmail: string;
    bankName: string;
    accountNumber: string;
    legalEntity: string;
    sapCode: string;
    time: any;
    disclaimer: string;
    timeSingle: string;
    timeType: string;
    tc: string;
    segrateTimeSlot: string;
    mapImage: string;
  };
  uploadedImage: any;
  onTimeSelect: any;
  time: any;
  onVisitTimeChange: any;
  timeType: any;
  timeSingle: any;
  dynamicPromoData: any;
  dynamicPromoType: any;
  onUpdateDetails: any;
  onChangeDetails: any;
  onDynamicPromoChange: any;
  onProductSelect: any;
  dynamicPromoError: any;
  restrictProductDiscount: any;
  productsOptions: any;
  onRestrictedProductChange: any;
  onUpdateRestrictedProduct: any;
}

const AddOutletForm = ({
  id,
  onSubmit,
  onCancel,
  onChange,
  onRemove,
  value,
  error,
  uploadedImage,
  onTimeSelect,
  onVisitTimeChange,
  time,
  timeType,
  timeSingle,
  dynamicPromoData,
  dynamicPromoType,
  onUpdateDetails,
  onChangeDetails,
  onDynamicPromoChange,
  onProductSelect,
  dynamicPromoError,
  restrictProductDiscount,
  productsOptions,
  onRestrictedProductChange,
  onUpdateRestrictedProduct,
}: Props) => {
  function getFlagName(countryCode: string) {
    let newArr = countryCodeData.filter(
      (eachData) => eachData.callingCode === countryCode
    );
    if (newArr.length) return newArr[0].flag;
    else return require(`../../assets/images/flags/qa.png`);
  }

  const onTimeChange = (event: any, value: any, name: string) => {
    const newTime = value.replace(/-/g, ":");
    const timeVal = newTime.substr(0, 5);
    onTimeSelect(timeVal, event.target.name, name);
  };

  return (
    <Container>
      <Box>
        <FormWrapper>
          <FormRow>
            <FieldWrapper>
              <Textfield
                name="name"
                label="Name"
                placeholder="Enter Name"
                onChange={onChange}
                value={value.name}
                required
                helperText={error["name"]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Selectfield
                name="type"
                label="Type"
                onChange={onChange}
                value={value.type}
                required
                helperText={error["type"]}
                data={OUTLET_TYPES_PARK}
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <Textfield
                name="email"
                label="Email"
                onChange={onChange}
                placeholder="Enter Email"
                value={value.email}
                required={false}
                helperText={error["email"]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <TextfieldWithImage
                inputName="phoneNumber"
                selectName="countryCode"
                label="Phone Number"
                placeholder="Enter phone number"
                onChange={onChange}
                inputValue={value.phoneNumber}
                selectValue={value.countryCode}
                required={false}
                helperText={error["phoneNumber"]}
                imageLink={
                  value.countryCode === ""
                    ? require(`../../assets/images/flags/qa.png`)
                    : getFlagName(value.countryCode)
                }
                selectData={countryCodeData}
                type={"dropdown"}
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <TextArea
                label="Information"
                placeholder="About"
                onChange={onChange}
                value={value.info}
                name="info"
                required
                helperText={error["info"]}
                rows={14}
              />
            </FieldWrapper>
            <FieldWrapper>
              <TextfieldWithImage
                inputName="whatsappNumber"
                label="Connect"
                placeholder="Enter Whatsapp Number"
                onChange={onChange}
                inputValue={value.whatsappNumber}
                required={false}
                helperText={error["whatsappNumber"]}
                imageLink={require(`../../assets/images/img_whatsapp.png`)}
                type="image"
              />
              <Gap height="6px" />
              <TextfieldWithImage
                inputName="instaLink"
                placeholder="Enter Instagram Link"
                onChange={onChange}
                inputValue={value.instaLink}
                required={false}
                helperText={error["instaLink"]}
                imageLink={require(`../../assets/images/img_insta.png`)}
                type="image"
              />
              <Gap height="6px" />
              <TextfieldWithImage
                inputName="fbLink"
                placeholder="Enter Facebook Link"
                onChange={onChange}
                inputValue={value.fbLink}
                required={false}
                helperText={error["fbLink"]}
                imageLink={require(`../../assets/images/img_fb.png`)}
                type="image"
              />
              <Gap height="6px" />
              <TextfieldWithImage
                inputName="tripAdvisor"
                placeholder="Enter Trip Advisor Link"
                onChange={onChange}
                inputValue={value.tripAdvisor}
                required={false}
                imageLink={require(`../../assets/images/img_tripadvisor.png`)}
                helperText={error["tripAdvisor"]}
                type="image"
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <Textfield
                name="disclaimer"
                label="Disclaimer"
                placeholder="Enter disclaimer if any"
                onChange={onChange}
                value={value.disclaimer}
                helperText={error["disclaimer"]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Textfield
                name="tc"
                label="Terms & Conditions"
                placeholder="Enter Terms & Conditions"
                onChange={onChange}
                value={value.tc}
                helperText={error["tc"]}
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <Selectfield
                name="type"
                label="Type of Price"
                onChange={onVisitTimeChange}
                value={timeType}
                required
                helperText={error["timeType"]}
                data={[
                  { label: "Select Timing", value: "" },
                  { label: "Single Time", value: "single" },
                  { label: "Multi Time", value: "multi" },
                ]}
              />
            </FieldWrapper>
            <FieldWrapper>
              {/* <TimeFieldWrapper> */}
              <TimeRangeSelector
                name="timeSingle"
                label="Sun to Sat"
                placeholder="Sun to Sat"
                onTimeChange={(e, val) => onTimeChange(e, val, "timeSingle")}
                value={timeSingle}
                required={timeType === "single"}
                disabled={!timeType || timeType === "multi"}
                helperText={error["timeSingle"]}
                fullWidth
              />
              {/* </TimeFieldWrapper> */}
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <TimeWrapper>
              <TimeRangeSelector
                name="mon"
                label="Mon"
                placeholder="Monday"
                onTimeChange={(e, val) => onTimeChange(e, val, "mon")}
                value={time["mon"]}
                required={false}
                disabled={!timeType || timeType === "single"}
                helperText={error?.time["mon"]}
              />
              <TimeRangeSelector
                name="tue"
                label="Tue"
                placeholder="Tuesday"
                onTimeChange={(e, val) => onTimeChange(e, val, "tue")}
                value={time["tue"]}
                required={false}
                disabled={!timeType || timeType === "single"}
                helperText={error?.time["tue"]}
              />
              <TimeRangeSelector
                name="wed"
                label="Wed"
                placeholder="Wednesday"
                onTimeChange={(e, val) => onTimeChange(e, val, "wed")}
                value={time["wed"]}
                required={false}
                disabled={!timeType || timeType === "single"}
                helperText={error?.time["wed"]}
              />
              <TimeRangeSelector
                name="thu"
                label="Thu"
                placeholder="Thursday"
                onTimeChange={(e, val) => onTimeChange(e, val, "thu")}
                value={time["thu"]}
                required={false}
                disabled={!timeType || timeType === "single"}
                helperText={error?.time["thu"]}
              />
              <TimeRangeSelector
                name="fri"
                label="Fri"
                placeholder="Friday"
                onTimeChange={(e, val) => onTimeChange(e, val, "fri")}
                value={time["fri"]}
                required={false}
                disabled={!timeType || timeType === "single"}
                helperText={error?.time["fri"]}
              />
              <TimeRangeSelector
                name="sat"
                label="Sat"
                placeholder="Saturday"
                onTimeChange={(e, val) => onTimeChange(e, val, "sat")}
                value={time["sat"]}
                required={false}
                disabled={!timeType || timeType === "single"}
                helperText={error?.time["sat"]}
              />
              <TimeRangeSelector
                name="sun"
                label="Sun"
                placeholder="Sunday"
                onTimeChange={(e, val) => onTimeChange(e, val, "sun")}
                value={time["sun"]}
                required={false}
                disabled={!timeType || timeType === "single"}
                helperText={error?.time["sun"]}
              />
            </TimeWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <Textfield
                name="lat"
                label="Location"
                placeholder="Add Latitude"
                onChange={onChange}
                value={value.lat}
                required
                helperText={error["lat"]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Gap height="24px" height2="0px" />
              <Textfield
                name="long"
                placeholder="Add Longitude"
                onChange={onChange}
                value={value.long}
                required
                helperText={error["long"]}
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <Textfield
                name="address"
                label="Address"
                placeholder="Enter Address"
                onChange={onChange}
                value={value.address}
                required
                helperText={error["address"]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Textfield
                name="iframe_url"
                label="External URL"
                placeholder="Enter external url"
                onChange={onChange}
                value={value?.iframe_url}
                required={false}
                helperText={error["iframe_url"]}
              />
            </FieldWrapper>
          </FormRow>
        </FormWrapper>
      </Box>

      <StyledPageHeader>Slot Duration</StyledPageHeader>
      <Box>
        <FormWrapper>
          <FormRow>
            <FieldWrapper>
              <Textfield
                name="segrateTimeSlot"
                label="Slot Duration"
                placeholder="Enter Slot Duration"
                onChange={onChange}
                value={value.segrateTimeSlot}
                helperText={error["segrateTimeSlot"]}
              />
            </FieldWrapper>
          </FormRow>
        </FormWrapper>
      </Box>

      <StyledPageHeader>Park Attachment</StyledPageHeader>
      <Box>
        <FormWrapper>
          <FormRow>
            <FieldWrapper>
              <UploadOutletImages
                name="logoUrl"
                label="Upload Logo"
                onChange={onChange}
                onRemove={onRemove}
                required
                uploadedImage={uploadedImage}
                helperText={error["logoUrl"]}
                maxImages={1}
                subLabel="Only JPEG or PNG files are allowed. Max size: 2MB. Recommended dimensions: 512x512"
                urls={value.logoUrl}
                acceptFormats=".jpeg, .jpg, .png"
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <UploadParkImages
                name="imageUrl"
                label="Upload Park image"
                onChange={onChange}
                onRemove={onRemove}
                required
                uploadedImage={uploadedImage}
                helperText={error["imageUrl"]}
                maxImages={4}
                subLabel="Only JPEG or PNG files are allowed. Max size: 2MB. Recommended dimensions: 672x378."
                urls={value.imageUrl}
                acceptFormats=".jpeg, .jpg, .png"
              />
            </FieldWrapper>
          </FormRow>
        </FormWrapper>
      </Box>
      <StyledPageHeader>Map</StyledPageHeader>
      <Box>
        <FormRow>
          <UploadOutletImages
            name="mapImage"
            label="Upload Map image"
            onChange={onChange}
            onRemove={onRemove}
            required
            uploadedImage={uploadedImage}
            helperText={error["mapImage"]}
            maxImages={1}
            subLabel="Only JPEG, PNG file with max size of 2MB"
            urls={value.mapImage}
            acceptFormats=".jpeg, .jpg, .png"
          />
        </FormRow>
      </Box>
      {/* <StyledPageHeader>Master</StyledPageHeader>
      <Box>
        <FormRow>
          <FieldWrapper>
            <Textfield
              name="masterName"
              label="Name"
              placeholder="Enter Name"
              onChange={onChange}
              value={value.masterName}
              helperText={error["masterName"]}
            />
          </FieldWrapper>
          <FieldWrapper>
            <FieldWrapper>
              <Textfield
                name="masterEmail"
                label="Email"
                placeholder="Enter Email"
                onChange={onChange}
                value={value.masterEmail}
                helperText={error["masterEmail"]}
              />
            </FieldWrapper>
          </FieldWrapper>
        </FormRow>
      </Box>

      <StyledPageHeader>Payment</StyledPageHeader>
      <Box>
        <FormRow>
          <FieldWrapper>
            <Textfield
              name="bankName"
              label="Bank Name"
              placeholder="Enter Bank Name"
              onChange={onChange}
              value={value.bankName}
              helperText={error["bankName"]}
            />
          </FieldWrapper>
          <FieldWrapper>
            <FieldWrapper>
              <Textfield
                name="accountNumber"
                label="Bank Account Number"
                placeholder="Enter Bank Account Number"
                onChange={onChange}
                value={value.accountNumber}
                helperText={error["accountNumber"]}
              />
            </FieldWrapper>
          </FieldWrapper>
        </FormRow>
      </Box>

      <StyledPageHeader>Legal</StyledPageHeader>
      <Box>
        <FormRow>
          <FieldWrapper>
            <Textfield
              name="legalEntity"
              label="Legal Entity"
              placeholder="Enter Legal Entity"
              onChange={onChange}
              value={value.legalEntity}
              helperText={error["legalEntity"]}
            />
          </FieldWrapper>
          <FieldWrapper>
            <FieldWrapper>
              <Textfield
                name="sapCode"
                label="SAP Company Code"
                placeholder="Enter SAP Company Code"
                onChange={onChange}
                value={value.sapCode}
                helperText={error["sapCode"]}
              />
            </FieldWrapper>
          </FieldWrapper>
        </FormRow>
      </Box> */}
      <StyledPageHeader>Date Configurations</StyledPageHeader>
      <Box>
        <FormRow>
          <FieldWrapper>
            <MultiDateSelector
              fullWidth
              label="Special Product Dates"
              placeholder="Select Dates"
              onDateSelect={onChange}
              required={false}
              helperText={""}
              name="specialProductsDates"
              value={value?.specialProductsDates.map((dates: any) =>
                dates.replaceAll("-", "/")
              )}
            />
          </FieldWrapper>

          <FieldWrapper>
            <MultiDateSelector
              label="Holiday Bookings Allowed Dates"
              fullWidth
              placeholder="Select Date"
              onDateSelect={onChange}
              required={false}
              helperText={""}
              name="holidayAllowedDates"
              value={value.holidayAllowedDates.map((dates: any) =>
                dates.replaceAll("-", "/")
              )}
            />
          </FieldWrapper>
          <FieldWrapper>
            <MultiDateSelector
              fullWidth
              label="Restricted Dates"
              placeholder="Select Dates"
              onDateSelect={onChange}
              required={false}
              helperText={""}
              name="restrictedDates"
              value={value.restrictedDates.map((dates: any) =>
                dates.replaceAll("-", "/")
              )}
            />
          </FieldWrapper>
        </FormRow>
        <Note>
          <strong style={{ fontWeight: 900 }}>
            Note: Entries with dates before today are automatically discarded.
          </strong>
        </Note>
      </Box>
      {id && (
        <RestrictProductDiscount
          restrictProductDiscount={restrictProductDiscount}
          parkProducts={productsOptions || []}
          onChange={onRestrictedProductChange}
          onUpdateRestrictedProduct={onUpdateRestrictedProduct}
        />
      )}
      {id && (
        <DynamicPromoForm
          onChange={onDynamicPromoChange}
          value={dynamicPromoData}
          error={dynamicPromoError}
          dynamicPromoType={dynamicPromoType}
          onUpdateDetails={onUpdateDetails}
          onChangeDetails={onChangeDetails}
          onProductSelect={onProductSelect}
        />
      )}
      <ActionRow>
        <ButtonWrapper>
          <Button
            variant="outlined"
            label="Cancel"
            onClick={onCancel}
            width="9.7rem"
          />
          <Button
            color={Colors.red}
            variant="filled"
            label="Save"
            onClick={onSubmit}
            width="9.7rem"
          />
        </ButtonWrapper>
      </ActionRow>
    </Container>
  );
};

interface GapProps {
  height: string;
  height2?: string;
}

const StyledPageHeader = styled.div`
  font-size: 1.25rem;
  font-family: "Poppins-Medium";
  line-height: 1.75rem;
  margin-top: 1.5rem;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const FieldWrapper = styled.div`
  flex: 1;
  @media only screen and (max-width: 768px) {
    margin-top: 0.5rem;
  }
`;

const TimeFieldWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: space-between;
  @media only screen and (max-width: 768px) {
    flex: 1;
  }
`;
const TimeWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: space-between;
  @media only screen and (max-width: 768px) {
    flex: 1;
  }
`;

const ButtonWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  gap: 1.5rem;
  @media only screen and (max-width: 768px) {
    gap: 0.5rem;
    margin-top: 2rem;
  }
  @media only screen and (max-width: 350px) {
    flex-direction: column-reverse;
    align-items: center;
  }
`;

const ActionRow = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
`;

const FormRow = styled.div`
  display: flex;
  gap: 0.5rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const FormGrid = styled.div`
  display: grid;
  gap: 1.5rem;
  grid-template-columns: 1fr 1fr 1fr;
  @media only screen and (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
  @media only screen and (max-width: 468px) {
    grid-template-columns: 1fr;
  }
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  @media only screen and (max-width: 768px) {
    gap: 0.5rem;
  }
`;

const Container = styled.div`
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  @media only screen and (max-width: 768px) {
    margin-top: 0.5rem;
  }
`;
export const Gap = styled.div<GapProps>`
  height: ${(GapProps) => GapProps.height};
  @media only screen and (max-width: 768px) {
    height: ${(GapProps) =>
      GapProps.height2 ? GapProps.height2 : GapProps.height};
  }
`;

const Note = styled.div`
  border-radius: 4px;
  color: ${Colors.blackOpacity};
  font-size: 12px;
  margin-top: 24px;
  font-style: italic;
  strong {
    // font-style: italic;
    font-weight: 700; // or 900 if your font supports it
    color: ${Colors.black}; // Optional: make it stand out
  }
`;

export default AddOutletForm;
